import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';

import pagination from './pagination';
import { userStatus } from '../constants';

const keyword = (state = "", action) => {
  switch (action.type) {
    case actionTypes.CHANGE_SEARCH_KEYWORD:
      return action.keyword;
    default:
      return state;
  }
}

const userName = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_USER_NAME:
      return action.userName;
    default:
      return state;
  }
}

const status = (state = userStatus.active, action) => {
  switch (action.type) {
    case actionTypes.SET_STATUS:
      return action.status;
    default:
      return state;
  }
}

export default combineReducers({
  keyword,
  userName,
  pagination,
  status
});

const getCurrentState = state => state.users.usersSearchForm;

export const getKeyword = state => getCurrentState(state).keyword

export const getUserName = state => getCurrentState(state).userName

export const getPagination = state => getCurrentState(state).pagination


// export const getPagination = state => {
//   const { pagination } = getCurrentState(state);

//   // var totalPage = parseInt(pagination.totalRecord / pagination.rowsPerPage, 0);
//   // if(pagination.totalRecord % pagination.rowsPerPage > 0)
//   //   totalPage++;
//   return {
//     ...pagination,
//     // totalPage
//   }
// }

export const getStatus = state => getCurrentState(state).status